import React from "react";
import { Input } from "@elaniintc/goes-design-system";

interface NumberOperationInputProps {
  /** Tipo de operación numérica */
  operation: string;
  /** Elementos para gestionar los valores */
  elements: Array<{ id?: string; value?: string }>;
  /** Callback para actualizar elementos */
  onElementsChange: (elements: Array<{ id?: string; value?: string }>) => void;
  /** Grupo de elementos */
  group?:
    | "down-left"
    | "down"
    | "down-right"
    | "left"
    | "right"
    | "up"
    | "up-left"
    | "up-right"
    | "single"
    | "middle"
    | "middle-right"
    | "middle-left";
}

/**
 * Componente para renderizar inputs específicos de operaciones numéricas
 */
export const NumberOperationInput: React.FC<NumberOperationInputProps> = ({
  operation,
  elements,
  onElementsChange,
  group = "down-left",
}) => {
  const updateElement = (index: number, value: string) => {
    const newElements = [...elements];
    while (newElements.length <= index) {
      newElements.push({
        id: Math.random().toString(36).substr(2, 9),
        value: "",
      });
    }
    newElements[index] = { ...newElements[index], value };
    onElementsChange(newElements);
  };

  // Operations that need a single input
  if (["power", "round", "ceil", "floor", "ln", "exp"].includes(operation)) {
    const getPlaceholder = () => {
      switch (operation) {
        case "power":
          return "Escribe el potenciador";
        case "round":
        case "ceil":
        case "floor":
          return "Escribe la cantidad de decimales";
        case "ln":
          return "Escribe el valor dado";
        case "exp":
          return "Escribe la potencia";
        default:
          return "";
      }
    };

    return (
      <>
        <Input
          className="w-full"
          group={group}
          placeholder={getPlaceholder()}
          maxLength={16}
          value={elements[0]?.value || ""}
          onChange={(e) => {
            // Use regex to match valid number format with max 4 decimal places
            const match = e.target.value.match(/^\d*\.?\d{0,4}/);
            const value = match ? match[0] : "";
            updateElement(0, value);
          }}
        />
      </>
    );
  }

  return null;
};
